import DebugActionType from '@/store/modules/debugger/debugger.type'
import { newInstance } from '@jsplumb/browser-ui'
import DebuggerService from '@/services/debugger.service'
import router from '@/router/router'
import { make } from 'vuex-pathify'
import { scaleBigger, scaleSmaller } from '@/modules/fptai/utils/canvas.util'
import _ from 'lodash'

const types = DebugActionType
const state = {
    instance: undefined,
    scenarioViewOffsetPosition: [0, 0],
    scenarioViewScale: 1,
    chatHistories: [],
    filter: {
        senderId: '',
        range: ''
    },
    sender: {},
    hasReachMax: false,
    request_id: '',
    debugData: [],
    cardActive: null,
    loading: false
}
const mutations = {
    ...make.mutations(state),
    [types.INIT_INSTANCE]: (state, container) => {
        if (state.instance) {
            state.instance.destroy()
            state.instance.reset()
            state.instance = undefined
        }

        state.instance = newInstance({
            container
        })
        state.instance.registerConnectionTypes({
            'fci-transparent': {
                paintStyle: {
                    strokeWidth: 1,
                    stroke: 'transparent'
                }
            },
            'fci-normal': {
                paintStyle: {
                    strokeWidth: 1,
                    stroke: '#D2D2D2'
                }
            }
        })
    },
    setViewOffsetPosition (state, payload) {
        state.scenarioViewOffsetPosition = payload
    },
    addAllChats (state, payload) {
        state.chatHistories = _.uniqBy([...state.chatHistories, ...payload], '_id')
    },
    setZoomLevel (state, { scale, offset }) {
        state.scenarioViewScale = scale
        state.instance.setZoom(scale)
        state.scenarioViewOffsetPosition = offset
    }
}
const actions = {
    ...make.actions(state),
    async fetchChatHistory ({ commit }, initial = false) {
        if (initial) {
            commit('SET_HAS_REACH_MAX', false)
            commit('SET_CHAT_HISTORIES', [])
        }
        if (state.hasReachMax) {
            return
        }
        const botCode = router.currentRoute.params.botCode
        const lastHistory = state.chatHistories.at(-1)
        const lastChatLogId = lastHistory ? lastHistory._id : undefined
        const query = { ...router.currentRoute.query, chat_log_id: lastChatLogId }
        const res = await DebuggerService.chatHistory(botCode, query)
        commit('addAllChats', res.data.data)
        commit('SET_SENDER', res.data.sender)
        if (res.data.data.length === 0) {
            commit('SET_HAS_REACH_MAX', true)
        }
    },
    async fetchDebugData ({ commit }) {
        const botCode = router.currentRoute.params.botCode
        const res = await DebuggerService.debugData(botCode, state.request_id)
        const debugData = res.data.data
        commit('SET_DEBUG_DATA', debugData.data)
        return debugData
    },
    zoomIn  ({ commit }) {
        const { scale, offset } = scaleBigger({
            scale: state.scenarioViewScale,
            offset: state.scenarioViewOffsetPosition
        })
        commit('setZoomLevel', { scale, offset })
    },

    zoomOut ({ commit }) {
        const { scale, offset } = scaleSmaller({
            scale: state.scenarioViewScale,
            offset: state.scenarioViewOffsetPosition
        })
        commit('setZoomLevel', { scale, offset })
    },
    wheelScroll ({ dispatch }, e) {
        if (e.deltaY > 0) {
            dispatch('zoomOut')
        } else {
            dispatch('zoomIn')
        }
        e.preventDefault()
    }

}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
